const byTech = [

  {
    
      title: "Cómo desplegar tu contrato en la red de pruebas o mainnet desde Remix IDE",
      value: `
   Una vez que tu contrato ha sido **compilado correctamente** y verificaste que no hay errores, ha llegado el momento de **desplegarlo en la blockchain**. Este proceso te permitirá tener tu contrato activo en una red de pruebas (testnet como Sepolia o Amoy) o incluso en la red principal (mainnet), dependiendo de tu objetivo.
    
  **¿Qué debes hacer ahora?**
    
Antes de desplegar, asegúrate de:
  - Tener tu wallet lista y conectada (MetaMask, por ejemplo).
  - Estar en la red adecuada (Sepolia, Amoy o mainnet).
  - Contar con fondos suficientes para pagar el gas (en testnets puedes usar faucets).
    
    ---
    
**Pasos para desplegar tu contrato en Remix IDE**
    
 
    
**1. Abre el panel de despliegue (Deploy & Run Transactions)**  
Haz clic en el ícono de “Deploy & Run Transactions” en la barra lateral izquierda (el ícono de Ethereum con un cohete).  
Aquí podrás seleccionar el entorno de despliegue y la cuenta desde la cual se hará el despliegue.
    
![Abrir panel de despliegue en Remix IDE](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-1a.png)
    
  ---
    
**2. Configura el entorno y la cuenta de despliegue**  
En el panel “Deploy & Run Transactions”, realiza lo siguiente:
- **ENVIRONMENT:** Selecciona el entorno donde deseas desplegar tu contrato:  
- **Remix VM** (entorno de pruebas interno)  
- **Injected Provider - MetaMask** (para usar Sepolia, Amoy, mainnet, etc.)
    - **ACCOUNT:** Elige la cuenta de wallet desde la que se pagarán las comisiones de gas.
    - **GAS LIMIT:** Usa el “Estimated Gas” o ajusta según lo necesites.
    - **VALUE:** Déjalo en 0 si no necesitas enviar ETH/MATIC al desplegar.
    - **CONTRACT:** Verifica que tu contrato esté seleccionado (por ejemplo, \`IERC20 - contracts/RealEstateToken.sol\`).
    
![Seleccionar Injected Provider - MetaMask en Remix IDE](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-2.png)
    ---





    
**3. Selecciona tu wallet MetaMask con Injected Provider en Remix IDE**
 
Para desplegar tu contrato en una red de pruebas o en la mainnet usando tu wallet MetaMask, debes seleccionar la opción **Injected Provider - MetaMask** en el menú de entorno ("ENVIRONMENT") del panel “Deploy & Run Transactions”.

**¿Cómo hacerlo?**
1. Ve al panel lateral izquierdo y abre el panel “Deploy & Run Transactions” (ícono de Ethereum con un cohete).
2. Haz clic en el menú desplegable de **ENVIRONMENT**.
3. Selecciona la opción **Injected Provider - MetaMask**.

![Seleccionar Injected Provider - MetaMask en Remix IDE](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-3.png)


    ---

**4. Autoriza la conexión de MetaMask con Remix IDE**

Al seleccionar **Injected Provider - MetaMask** como entorno de despliegue en Remix IDE, MetaMask abrirá automáticamente una ventana emergente para solicitar tu autorización de conexión.

**¿Qué debes hacer?**
1. Verifica que estás conectando la cuenta correcta (por ejemplo, la cuenta ESCUELA con saldo en SepoliaETH).
2. Si tienes varias cuentas, puedes editar la selección haciendo clic en "Editar cuentas".
3. Haz clic en **Conectar** para permitir que Remix interactúe con tu wallet.  
   Esto es necesario para firmar y pagar las transacciones de despliegue en la red de pruebas o mainnet.

Solo después de conectar, podrás desplegar tu contrato y realizar operaciones en la red seleccionada desde Remix IDE.

En la imagen puedes ver la ventana de autorización de MetaMask al intentar conectar con Remix.

![Seleccionar Injected Provider - MetaMask en Remix IDE](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-5a.png)

**5. Verifica tu cuenta, red y despliega tu contrato**

Una vez que hayas conectado correctamente tu wallet MetaMask y seleccionado **Injected Provider - MetaMask** como entorno de despliegue, asegúrate de lo siguiente antes de desplegar tu contrato:

- **ACCOUNT:** Verifica que la cuenta mostrada es la correcta (por ejemplo, \`0xC1bA4...6153a\`). Debe coincidir con la cuenta que autorizaste en MetaMask y tener saldo suficiente en la red seleccionada.
- **Red activa:** Asegúrate de estar en la red deseada (como **Sepolia**, que se muestra en la parte superior del panel). Si necesitas cambiar de red, hazlo directamente desde MetaMask antes de continuar.
- **GAS LIMIT:** Puedes dejar la opción “Estimated Gas” para que Remix calcule automáticamente el gas necesario para el despliegue.
- **VALUE:** Déjalo en 0 a menos que tu contrato requiera recibir ETH/MATIC durante el despliegue.
- **CONTRACT:** Verifica que el contrato correcto esté seleccionado en el campo correspondiente (por ejemplo, \`IERC20 - contracts/RealEstateToken.sol\`).

![Despliega tu contrato con la cuenta y red correctas](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-7.png)

    
**6. Verifica que tienes seleccionado el contrato correcto**

Antes de desplegar, revisa que el contrato mostrado en el campo CONTRACT es el que realmente quieres desplegar (por ejemplo, \`IERC20 - contracts/RealEstateToken.sol\`). Si tienes varios contratos compilados, haz clic en el menú desplegable y selecciona el contrato correcto de la lista.  
Esto es muy importante para evitar desplegar por error otro contrato o una versión antigua del código.

En la imagen puedes ver cómo elegir el contrato adecuado desde el menú desplegable:


![Seleccionar contrato correcto en Remix](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-8a.png)

**7. Cambia el contrato si seleccionaste uno incorrecto**

Si notas que el contrato seleccionado en el campo CONTRACT no es el que deseas desplegar (por ejemplo, aparece “TootyToken - contracts/RealEstateToken.sol” en lugar de tu contrato final), haz clic en el menú desplegable y selecciona el contrato correcto de la lista.  
Es fundamental asegurarte de desplegar la versión y el archivo que corresponde a tu proyecto.

En la imagen puedes ver cómo cambiar el contrato seleccionado antes de desplegar:

![Cambiar contrato seleccionado en Remix](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-9.png)

**8. Confirma la transacción en MetaMask para desplegar tu contrato**

Al hacer clic en **Deploy** en Remix IDE, se abrirá automáticamente MetaMask para pedirte que confirmes la transacción de implementación del contrato.  
Aquí podrás revisar los detalles, como la tarifa de red (gas) y la cuenta desde la que se enviará la transacción.  
Si todo está correcto, haz clic en **Confirmar** para autorizar el despliegue.  
En unos segundos, tu contrato estará en proceso de ser desplegado en la blockchain.

En la imagen puedes ver la ventana de confirmación de MetaMask al desplegar el contrato:

![Confirmar transacción en MetaMask](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-10a.png)

**9. Monitorea el estado de la transacción en MetaMask**

Después de confirmar la transacción para desplegar tu contrato, puedes monitorear el estado desde la pestaña “Actividad” de MetaMask.  
Aquí verás la implementación de contrato como “Pendiente” hasta que la transacción sea procesada y confirmada en la blockchain.  
No cierres Remix IDE ni MetaMask hasta que el proceso se complete.  
Si la red está congestionada, puede tardar algunos minutos.

En la imagen puedes ver cómo se muestra la transacción pendiente en MetaMask:

![Transacción pendiente en MetaMask](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-12a.png)

**10. Verifica que la transacción fue confirmada y tu contrato está desplegado**

Cuando la transacción de despliegue haya sido procesada exitosamente, MetaMask mostrará el estado como **Confirmado** en la pestaña de “Actividad”.  
Además, en Remix IDE aparecerá un check verde junto a la transacción, indicando que tu contrato ya fue implementado en la blockchain de la red seleccionada.

Ahora tu contrato está activo y puedes interactuar con él, copiar su dirección o consultarlo en el explorador de bloques correspondiente.

En la imagen puedes ver la confirmación tanto en MetaMask como en Remix IDE:

![Confirmación de contrato desplegado en MetaMask y Remix](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/23-13a.png)

**11. ¡Contrato desplegado exitosamente en la red de Sepolia!**

¡Listo! Has completado el proceso de despliegue de tu contrato inteligente en la red de pruebas Sepolia utilizando Remix IDE y MetaMask.  
Ahora puedes comenzar a interactuar con tu contrato, probar sus funciones desde Remix o compartir la dirección del contrato con otros usuarios y aplicaciones.

Recuerda que si necesitas verificar o explorar tu contrato, puedes hacerlo desde [Sepolia Etherscan](https://sepolia.etherscan.io/) buscando la dirección que se muestra en Remix IDE después del despliegue.

Si todo ha funcionado correctamente aquí, ¡estás listo para desplegar tu contrato en mainnet cuando lo decidas!


 
    

    `
    
    
  }
]

export default byTech;